<template>
  <div class="CustomerRechargeChart">
    <div
      id='CustomerRechargeChart'
      :style="`height: ${height}px;width: ${width?width+'px':'auto'}`"
    ></div>
    <div class="CustomerRechangeSlider-wrap">
      <div id='CustomerRechangeSlider'></div>
    </div>
    <!-- <CustomerRechangeSlider
      class="CustomerRechangeSlider"
      :data="data"
      :span="4"
      :onChange="wheelHandle"
    /> -->
  </div>
</template>

<script>
import G2 from '@antv/g2';
import Slider from '@antv/g2-plugin-slider';
import chartMixin from '../chartMixin';
import DataSet from '@antv/data-set';
import _ from 'lodash';
// import CustomerRechangeSlider from './slider';

// const Shape = G2.Shape;
// const Util = G2.Util;
// const Global = G2.Global;

// function getRectRange(points, step) {
//   var xValues = [];
//   var yValues = [];
//   for (var i = 0, len = points.length; i < len; i++) {
//     var point = points[i];
//     xValues.push(point.x);
//     yValues.push(point.y - step);
//   }
//   var xMin = Math.min.apply(null, xValues);
//   var yMin = Math.min.apply(null, yValues);
//   var xMax = Math.max.apply(null, xValues);
//   var yMax = Math.max.apply(null, yValues);

//   return {
//     x: xMin,
//     y: yMin,
//     width: xMax - xMin,
//     height: yMax - yMin,
//   };
// }
// function getRectDraw(step) {
//   return {
//     draw: function draw(cfg, container) {
//       var points = this.parsePoints(cfg.points);
//       var style = Util.mix(Global.shape.interval, cfg.style, {
//         fill: cfg.color,
//       });
//       var rectCfg = getRectRange(points, cfg.size * step); // cfg.size 对应 .size(25)

//       return container.addShape('rect', {
//         className: 'interval',
//         attrs: Util.mix(rectCfg, style),
//       });
//     },
//   };
// }
// // 左侧柱子
// Shape.registerShape('interval', 'left', getRectDraw(1.5));
// Shape.registerShape('interval', 'center', getRectDraw(0));
// // 右侧柱子
// Shape.registerShape('interval', 'right', getRectDraw(-1));

export default {
  name: 'CustomerRechargeChart',
  // components: { CustomerRechangeSlider },
  mixins: [chartMixin],
  props: {
    rechargeCount: {
      type: Object,
    },
  },
  data() {
    return {
      demoList: [
        { areaName: 'bvs', rechargeMoney: 13.45, rechargeMen: 12 },
        { areaName: 'gsn', rechargeMoney: 23.45, rechargeMen: 13 },
        { areaName: 'dsf', rechargeMoney: 12.45, rechargeMen: 16 },
        { areaName: 'bzx', rechargeMoney: 45.45, rechargeMen: 63 },
        { areaName: 'bvmf', rechargeMoney: 3213.454, rechargeMen: 32 },
        { areaName: 'swer', rechargeMoney: 256, rechargeMen: 125 },
        { areaName: 'cvsdf', rechargeMoney: 541, rechargeMen: 14 },
        { areaName: 'cvsdf', rechargeMoney: 10.15, rechargeMen: 574 },
      ],
      slider: null,
      sliderDom: null,
      ds: null,
      dv: null,
      SelectedDataIndex: null,
    };
  },
  computed: {
    dataList() {
      return this.data.map((item, index, array) => ({
        ...item,
        index: index,
        scaleValue: array.length - 1 ? index / (array.length - 1) : 0,
      }));
    },
  },
  methods: {
    initData() {
      let start =
        this.dataList.length - 4 >= 0
          ? (this.dataList.length - 4) / this.dataList.length
          : 0;
      let end = 1;
      this.ds = new DataSet({
        state: {
          start: start,
          end: end,
        },
      });
      const dv = this.ds.createView().source(this.dataList);
      this.dv = dv;

      dv.transform({
        type: 'map',
        callback(row) {
          row.refundMoney = Math.abs(row.refundMoney);
          return row;
        },
      }).transform({
        type: 'fold',
        fields: ['rechargeMoney', 'refundMoney'],
        key: 'name',
        value: 'count',
      });

      dv.transform({
        type: 'filter',
        callback: obj => {
          const currentRadio = obj.scaleValue;
          return (
            currentRadio >= this.ds.state.start &&
            currentRadio <= this.ds.state.end
          );
        },
      });

      this.chart = new G2.Chart({
        container: 'CustomerRechargeChart',
        forceFit: true,
        height: this.height,
        padding: [30, 90, 50, 120],
      });

      this.chart.source(dv, {
        rechargeMoney: {
          alias: '充值总额',
        },
        refundMoney: {
          alias: '退款总额',
        },
        rechargeMen: {
          alias: '充值笔数',
        },
        refundCount: {
          alias: '退款笔数',
        },
      });

      this.chart.axis('areaName', {
        label: {
          offsetX: -80,
          htmlTemplate: (text, item, index) => {
            return `<div class="CustomerRechargeChart-areaTitle">${text}</div>`;
          },
        },
      });

      this.chart.coord().transpose();

      this.chart
        .interval()
        .position('areaName*count')
        .size(10)
        .color('name', ['#26c9a8', '#fb774e'])
        .adjust([
          {
            type: 'dodge',
            dodgeBy: 'name',
            marginRatio: -0.4,
          },
        ])
        .tooltip(
          'name*count*rechargeMen*refundCount',
          (name, count, rechargeMen, refundCount) => {
            if (name === 'rechargeMoney') {
              return {
                name: '充值总额',
                value: count + `(笔数: ${rechargeMen})`,
              };
            }
            if (name === 'refundMoney') {
              return {
                name: '退款总额',
                value: count + `(笔数: ${refundCount})`,
              };
            }
          }
        );

      this.chart.legend(false);

      this.chart.guide().text({
        top: true,
        position: ['100%', '100%'],
        content: '(元)',
        offsetX: 30,
        offsetY: 8,
      });

      this.chart.render();

      this.initSlider();
    },
    initSlider() {
      const wrapDom = document.getElementById('CustomerRechargeChart');
      // let height = wrapDom.clientHeight;

      // const arrLength = this.data.length;
      // let spanNum = 4 / arrLength;
      this.sliderDom = document.getElementById('CustomerRechangeSlider');
      this.sliderDom.style = `height:${this.height}px`;

      const spanNum = 4 / this.dataList.length;

      this.slider = new Slider({
        container: this.sliderDom, // dom 容器 id 或者 dom 容器对象
        width: 26, // slider 的宽度，默认为 'auto'，即自适应宽度
        height: this.height, // slider 的高度，默认为 '26px'
        padding: [20, 0, 20, 0],
        xAxis: 'rechargeMen', // 背景图的横轴对应字段，同时为数据筛选的字段
        yAxis: 'scaleValue', // 背景图的纵轴对应字段
        start: 0,
        end: 3 / this.dataList.length,
        minSpan: spanNum,
        maxSpan: spanNum,
        data: this.dataList, // slider 的数据源
        textStyle: {
          display: 'none',
        },
        handleStyle: {
          img: require('@/assets/images/dashboard/QXtfhORGlDuRvLXFzpsQ.png'),
          width: 26,
          height: 5,
        },
        onChange: ({ startValue, endValue }) => {
          this.ds.setState('start', startValue);
          this.ds.setState('end', endValue);
        }, // 更新数据状态量的回调函数
      });
      this.slider.layout = 'vertical';
      this.slider.render(); // 渲染
    },
    updateSlider() {
      this.sliderDom.innerHTML = '';

      const arrLength = this.dataList.length;
      let start =
        this.dataList.length - 4 >= 0
          ? (this.dataList.length - 4) / this.dataList.length
          : 0;
      let end = 1;
      // console.log('2222', this.dataList.length - 1, start, end);
      const spanNum = 4 / this.dataList.length;

      if (arrLength) {
        this.slider = new Slider({
          container: this.sliderDom,
          width: 26,
          height: this.height,
          padding: [20, 0, 20, 0],
          xAxis: 'count',
          yAxis: 'scaleValue',
          scales: {
            scaleValue: {
              formatter: val => {
                let indexValue = val * (this.dataList.length - 1);
                // console.log(val, indexValue);
                return parseInt(indexValue, 10);
              },
            },
          },
          start: start,
          end: end,
          minSpan: spanNum,
          maxSpan: spanNum,
          data: this.dataList,

          handleStyle: {
            img: require('@/assets/images/dashboard/QXtfhORGlDuRvLXFzpsQ.png'),
            width: 26,
            height: 5,
          },
          onChange: ({ startValue, endValue }) => {
            // console.log('update:', startValue, endValue);
            this.ds.setState('start', startValue);
            this.ds.setState('end', endValue);
          },
        });
        this.slider.layout = 'vertical';
        this.slider.render();
      }
    },
    refreshData() {
      if (this.chart) {
        const arrLength = this.data.length;
        let spanNum = 4 / arrLength;
        let start =
          this.dataList.length - 4 >= 0
            ? (this.dataList.length - 4) / this.dataList.length
            : 0;
        let end = 1;

        this.ds.setState('start', start);
        this.ds.setState('end', end);
        this.dv.source(this.dataList);

        this.updateSlider();
        this.updateData();
        // console.log(this.chart.getYScales());
      } else {
        this.initData();
        this.initSlider();
      }
    },
    wheelHandle({ startRadio, endRadio }) {
      const tStartRadio = Math.abs(1 - endRadio);
      const sEndRadio = Math.abs(1 - startRadio);
      console.log(tStartRadio, sEndRadio);

      this.ds.setState('startRadio', tStartRadio);
      this.ds.setState('endRadio', sEndRadio);
    },
  },
};
</script>

<style lang="scss">
.CustomerRechargeChart {
  position: relative;
  .CustomerRechangeSlider-wrap {
    position: absolute;
    right: 0;
    top: 0;
    width: 26px;
    height: 100%;
  }
  #CustomerRechargeChart {
    width: 100%;
    // overflow-x: hidden;
    // overflow-y: auto;
  }
  .CustomerRechangeSlider {
    position: absolute;
    top: 0;
    right: 0;
    width: 28px;
    height: 100%;
    background-color: #eee;
  }
  .CustomerRechargeChart-areaTitle {
    color: #666;
    width: 85px;
    height: 2.4em;
    line-height: 1.2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
